import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { SecretRecord } from "../SecretRecord";

export const getQueryKey = (secretName?: string) => {
  if (secretName === undefined) {
    return ["secretValue"];
  }

  return ["secretValue", secretName];
};

export function useSecretValue(
  secretRecord: SecretRecord,
  enabled: boolean = false,
) {
  const { secretService } = useDomainServices();

  return useQuery<string, Error>({
    queryKey: getQueryKey(secretRecord.name),
    queryFn: async () => {
      return secretService.getSecretValue(secretRecord);
    },
    // only fetch secret value when user clicks "show secret" by default
    enabled,
  });
}
